// The pieces every errored control shares: the line under it and the
// attributes that make it announce itself. Its own module so the signature
// pad and FieldInput can both use them without importing each other.

/** The error line under a control. `role="alert"` so it is read out the moment it appears. */
export function FieldError({ id, text }: { id: string; text?: string }) {
  if (!text) return null;
  return <div className="of-error of-field-error" id={id} role="alert">{text}</div>;
}

/**
 * The attributes that make an errored control announce itself: the invalid
 * state, the description chain (help text first, then the error) and the path
 * the summary uses to jump here.
 */
export function errorAttrs(domId: string, error: string | undefined, path: string, hasInfo: boolean) {
  const described = [hasInfo ? `${domId}-info` : '', error ? `${domId}-err` : ''].filter(Boolean).join(' ');
  return {
    'aria-invalid': error ? (true as const) : undefined,
    'aria-describedby': described || undefined,
    'data-error-path': error ? path : undefined,
  };
}

